module.exports = __webpack_public_path__ + "./assets/img_hualien_color@2x__3ddcf39fd3e3c044767a0f0085df1b20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_hualien_color@2x.jpg
// module id = 617
// module chunks = 12